/**
 * Teléfono/celular de auxiliares (México).
 * Uso futuro previsto: WhatsApp Business API (no implementado aún).
 */

/** Limpia espacios, guiones y paréntesis; conserva + al inicio si existe. */
export function stripPhoneFormatting(raw) {
  const s = String(raw || "").trim();
  if (!s) return "";
  const hasPlus = s.startsWith("+");
  const digits = s.replace(/\D/g, "");
  return hasPlus && digits ? `+${digits}` : digits;
}

export const AUXILIARY_PHONE_HELP =
  "Opcional. Se usará más adelante para WhatsApp Business. Ej: 8136475360 o +52 81 3647 5360.";
